export default __webpack_public_path__ + "static/media/partner-connect.069c5e45.svg";